import React from 'react'
import "./header.css"
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import PhoneIcon from '@mui/icons-material/Phone';

export default function Header() {
  return (
    <div>
        <header>
        <div className="openingtime">
            <AccessTimeIcon className="icon"/> Monday - Saturday: 9:00 - 18:00, Sunday 14:00 - 18:00
        </div>
        
        <div className="socialmedia">
          
            <a href="https://www.facebook.com/paragonhomessolutions?mibextid=ZbWKwL"><FacebookIcon className="icon"/></a>

            <a href="https://www.instagram.com/invites/contact/?i=a60hx0qslbt3&utm_content=nm7xwue"><InstagramIcon className="icon"/></a>
           
            <span > <a href='mailto: info@paragonhomessolutions.com'>  info@paragonhomessolutions.com</a></span>
            <PhoneIcon className="icon1" style={{paddingLeft: "20px", paddingRight: "10px", cursor: "pointer"}}/> <a href="tel:+254773722209">
            +254 104141843</a>

        </div>
        </header>
    </div>
  )
}
